import { Component, OnInit, Inject, ViewChild, TemplateRef, Output, EventEmitter, Input, Injector } from '@angular/core';
import IdentificationTypesFormComponentView from './identification-types-form.component.html';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { LogService } from '../../../../core/services/log.service';
import { IdentificationType } from '../../../../shared/models/common/identification-type.model';
import { Country } from '../../../../shared/models/common/country.model';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IdentificationTypesService } from '../../services/identification-types.service';

import { CheckboxModule } from 'primeng/checkbox';

@Component({
    selector: 'identification-types-form',
    template: IdentificationTypesFormComponentView,
    imports: [
        CheckboxModule,
    ],
})

export class IdentificationTypesFormComponent implements OnInit {

    @ViewChild('activeTemplate', { static: true }) activeTemplate!: TemplateRef<any>;

    private identificationTypeForm: FormGroup;
    private identificationType: IdentificationType;
    private countryOptions: Country[];
    private getIdentificationType() {
        if (this.$stateParams.id) {

            this.IdentificationTypesService.getIdentificationType(this.$stateParams.id).subscribe({

                next: (identificationTypeData) => {

                    this.identificationType = identificationTypeData;
                    this.identificationTypeForm.patchValue(identificationTypeData);

                },

                error: (err) => {
                    console.error('Something went wrong... ', err);
                }

            })

        }
    };

    private getCountryOptions() {
        this.IdentificationTypesService.getAllCountries().subscribe({

            next: (countriesData) => {
                this.countryOptions = countriesData;
            },

            error: (err) => {
                console.error('Something went wrong... ', err);
            }
        })
    };

    private goToCancel() {

        this.$state.go('common.identificationtypes.list');

    }
   
     private checkDelete() {

        this.confirmationService.confirm({
            message: this.translate.instant('identification_types.check_delete'),
            header: this.translate.instant('general.remove'),
            accept: () => {
                this.IdentificationTypesService.deleteIdentificationType(this.identificationType).subscribe({
                    next: () => {
                            this.$state.go('common.identificationtypes.list');
                    }
                });
            },
            reject: () => {
                // Optional: action on reject (cancel)
            }
        });
     }

    private saveIdentificationType() {

        this.identificationType = {
            id: this.identificationType.id,
            ...this.identificationTypeForm.value
        };

        this.IdentificationTypesService.saveIdentificationType(this.identificationType).subscribe({

            next: () => {
                this.$state.go('common.identificationtypes.list');
            },
            error: (errorResponse) => {

                console.log(errorResponse);

                this.confirmationService.confirm({
                    message: errorResponse.error.ExceptionMessage,
                    header: this.translate.instant('general.error'),
                    acceptVisible: false,
                    rejectLabel: this.translate.instant('general.accept'),
                    reject: () => { }
                });
            }, 
        });

    }

    constructor(@Inject(LogService) private log: LogService,
        @Inject(IdentificationTypesService) private IdentificationTypesService: IdentificationTypesService,
        @Inject(MessageService) private messageService: MessageService,
        @Inject(FormBuilder) private formBuilder: FormBuilder,
        @Inject(ConfirmationService) private confirmationService: ConfirmationService,
        @Inject(TranslateService) private translate: TranslateService,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$state') private $state: any) { 

        const ng1Injector = (window as any).angular.element(document.body).injector();

        this.$stateParams = ng1Injector.get('$stateParams');
        this.$state = ng1Injector.get('$state');

        this.identificationType = {
            id: null,
            Name: null,
            Description: null,
            Active: false,
            Personal: false,
            CountryId: null,
            ValidationMethod: "",
            ValidationRegex: ""
        };

    }

    ngOnInit() {

        this.identificationTypeForm = this.formBuilder.group({
            Name: ['', Validators.required],
            Description: ['', Validators.required],
            Active: [false],
            Personal: [false],
            CountryId: null,
            ValidationMethod: ['', Validators.required],
            ValidationRegex: ['', Validators.required],

        });

        this.getIdentificationType();
        this.getCountryOptions();

    }

    ngAfterViewInit() {


    }

}
